/**
 * @file    engineSectionRegistry.tsx
 * @scope   ENTERPRISE
 * @summary Maps engine host-section keys (from `descriptor.hostLayout.mainSection`) to the drawer
 *          components that render them.
 * @consumes EnterpriseDataGridSection, Enterprise view keys
 * @produces EngineSectionProps, ENGINE_SECTIONS, renderEngineSection
 * @sideEffects None.
 * @notes   New subtypes register their main-tab section here; MainView never branches on subtype.
 *          Unknown key → nothing rendered (safe default).
 */
import React from 'react';
import { ENTERPRISE_VIEW_KEYS } from 'components/DiyWidgetEngine/Subtypes/Enterprise/descriptor';
import EnterpriseDataGridSection from './EnterpriseDataGridSection';
import { CPR_VIEW_KEYS } from 'components/DiyWidgetEngine/Subtypes/CrossProgramRollup/constants';
import CprRollupSection from './CprRollupSection';

/** Props every main-tab engine section receives (today: the Enterprise grid props). */
export type EngineSectionProps = {
  availableOptions: any;
  setSelectedPartition: (partition: any) => void;
  setCurrentTab: (tab: any) => void;
};

export const ENGINE_SECTIONS: Record<string, React.FC<EngineSectionProps>> = {
  [ENTERPRISE_VIEW_KEYS.dataGridSection]: EnterpriseDataGridSection,
  [CPR_VIEW_KEYS.rollupSection]: CprRollupSection,
};

/**
 * @param key Section key declared by the active descriptor.
 * @param props Section props.
 * @returns The section element, or `null` when no section is declared/registered.
 */
export const renderEngineSection = (
  key: string | undefined,
  props: EngineSectionProps
): React.ReactElement | null => {
  const Section = key ? ENGINE_SECTIONS[key] : undefined;
  return Section ? <Section {...props} /> : null;
};
